/**
 * Series first-open landing (#682). Picture lock 2026-08-24:
 * empty series, no Timeline pins → Series Discovery. Series that
 * already has pins → Timeline. Pins are Timeline items (book / gap /
 * entrance / exit / reveal). Chat-first empty series still lands on Series
 * Discovery. Never leftover Start Book 1 or the old Series Notes
 * /dashboard sheet.
 */

import { seriesBookBoardApi } from '../api/seriesBookBoard';
import { itemsFromBoard } from './seriesBookBoard';

export function seriesDiscoveryPath(project) {
  if (project?.discovery_session_id) {
    return `/chat/${project.discovery_session_id}`;
  }
  if (project?.id) return `/projects/${project.id}/discovery`;
  return '/projects';
}

export function seriesTimelinePath(projectId) {
  return projectId ? `/projects/${projectId}/series` : '/projects';
}

export function boardHasPins(board) {
  return itemsFromBoard(board).length > 0;
}

export async function resolveSeriesLandingPath(project, { getBoard } = {}) {
  if (!project?.id) return '/projects';
  const loadBoard = getBoard || ((id) => seriesBookBoardApi.get(id));
  try {
    const board = await loadBoard(project.id);
    if (boardHasPins(board)) return seriesTimelinePath(project.id);
  } catch {
    // Board read failed — still never leftover dashboard / Start Book 1.
  }
  return seriesDiscoveryPath(project);
}
